import React from "react";
import { ReactComponent as DeleteAccountIllustrationLogo } from "./DeleteAccountIllustrationLogo.svg";

function DeleteAccountIllustrationLogoIcon(props) {
  return <DeleteAccountIllustrationLogo {...props} />;
}

export default DeleteAccountIllustrationLogoIcon;
